import * as dto from 'client/dto';

export const isUserAdmin = (userProfile: dto.UserModel) =>
  userProfile &&
  userProfile.roles &&
  userProfile.roles.some(
    r =>
      r.name === 'Admin' ||
      r.name === 'ManageUsers' ||
      r.name === 'ViewUsers' ||
      r.name === 'AccountViewer' ||
      r.name === 'AccountManager'
  );
